export const authTranslation = {
  title: {
    verify_account: 'Entre com seu e-mail',
    login: 'Entre na sua conta',
    register: 'Crie sua conta',
  },
};
